module.exports = __webpack_public_path__ + "img/journal_prev.b9d0cec9.svg";